import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";

const STAT_LABELS = {
  blog_posts: "Blog Posts",
  blog_published: "Published Posts",
  gallery_items: "Gallery Items",
  testimonials: "Testimonials",
  newsletter_subscribers: "Newsletter Subscribers",
  appointments_pending: "Pending Appointments",
  appointments_total: "Total Appointments",
  contact_submissions: "Contact Submissions",
  admin_users: "Admin Users",
};

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/dashboard").then((res) => setStats(res.data)).catch(() => setStats({}));
  }, []);

  return (
    <AdminPageShell title="Dashboard" description="An overview of activity across the Gopi Gadhvi Group ecosystem." testId="admin-dashboard-page">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(STAT_LABELS).map(([key, label]) => (
          <div key={key} className="neu-surface p-6" data-testid={`admin-stat-${key}`}>
            <p className="text-small mb-2">{label}</p>
            <p className="text-h3" style={{ color: "var(--gg-logo-gold)" }}>{stats ? (stats[key] ?? "—") : "…"}</p>
          </div>
        ))}
      </div>
    </AdminPageShell>
  );
};

export default AdminDashboard;
